module.exports = __webpack_public_path__ + "static/img/img_5.dfc3c0e9.jpg";